<template>
  <div>
    <div class="custom-css" style="height: 100%; width: 100%">
      <svg
          data-v-084645b0=""
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          preserveAspectRatio="none meet"
          class=""
          style="height: 100%; width: 100%"
        >
          <rect
            data-v-084645b0=""
            x="10"
            y="10"
            :width="component.width - option.lineWidth"
            :height="component.height - option.lineWidth"
            class=""
            :style="rectStyle"
             :class="classType"
          ></rect>
        </svg>
    </div>
  </div>
</template>
<script>
export default {
  name: "avue-echart-Rectangle",
  props: {
    option: Object,
    component: Object,
  },
  data() {
    return {};
  },
  created(){
    console.log(this.component)
  },
  computed: {
    rectStyle() {
      let result = `fill: ${this.option.fillColor == ''?'transparent':this.option.fillColor};
              stroke-width: ${this.option.lineWidth};
              stroke: ${this.option.color};`
       switch (this.option.lineType) {
        case "dotted":
            result += 'stroke-dasharray: 5 5;'
          break; // 点线
        case "dashed":
            result += 'stroke-dasharray: 10 10;'
          break ; // 虚线线
        case "dashdot":
            result += 'stroke-dasharray: 10 10 2 10;'
          break; // 混合线：虚线+点线
      }
      return result
    },
    classType(){
      if(this.option.lineType == 'solid' || this.option.lineAnimation == ''){
        return ''
      }
      return this.option.lineFlow == 'positive' ? `animation-positive-${this.option.lineType}`:`animation-reverse-${this.option.lineType}`; 
    }
  },
};
</script>

<style scoped>
 @import url("../index.css");
</style>